<div id="w-node-f4c45083-6081-de4a-0ed5-caf2a4acb777-d41280b8" class="w-layout-layout quick-stack wf-layout-layout">
  <ng-container *ngIf="control?.parent?.get('service')?.value != '5'">
    <div id="w-node-f4c45083-6081-de4a-0ed5-caf2a4acb778-d41280b8" class="w-layout-cell cell-3">
      <div class="modern-selector" [class.selected]="control?.value == 'house'" (click)="changePropertyValue('house')">
        <img src="/assets/inquiry/ph_house.png" loading="lazy" width="45" alt="" class="icon">
        <div class="modern-selector-label">Haus</div>
      </div>
    </div>
    <div id="w-node-f4c45083-6081-de4a-0ed5-caf2a4acb779-d41280b8" class="w-layout-cell cell-3">
      <div class="modern-selector" [class.selected]="control?.value == 'flat'" (click)="changePropertyValue('flat')">
        <img src="/assets/inquiry/material-symbols-light_apartment.png" loading="lazy" width="45" alt="" class="icon">
        <div class="modern-selector-label">Wohnung</div>
      </div>
    </div>
    <div id="w-node-c3654d22-c292-d44e-b26d-84b63599780a-d41280b8" class="w-layout-cell cell-3">
      <div class="modern-selector" [class.selected]="control?.value == 'room'" (click)="changePropertyValue('room')">
        <img src="/assets/inquiry/cil_room.png" loading="lazy" width="45" alt="" class="icon">
        <div class="modern-selector-label">WG</div>
      </div>
    </div>
  </ng-container>
  <div id="w-node-_50ce9b6c-b8e9-f066-30d4-6af56ee99613-d41280b8" class="w-layout-cell cell-3">
    <div class="modern-selector" [class.selected]="control?.value == 'warehouse'" (click)="changePropertyValue('warehouse')">
      <img src="/assets/inquiry/material-symbols-light_warehouse-outline.png" loading="lazy" width="45" alt="" class="icon">
      <div class="modern-selector-label">Lager</div>
    </div>
  </div>
  <div id="w-node-f20fa909-09f6-f3dd-8310-83eea2109b04-d41280b8" class="w-layout-cell cell-3">
    <div class="modern-selector" [class.selected]="control?.value == 'office'" (click)="changePropertyValue('office')">
      <img src="/assets/inquiry/ph_office-chair.png" loading="lazy" width="45" alt="" class="icon">
      <div class="modern-selector-label">Büro</div>
    </div>
  </div>
</div>
